import { match } from 'ts-pattern';
// Based on the breakpoints of https://www.figma.com/file/0ot53XzazhcUOQTZta4wP3/Design-System-1.0?type=design&node-id=113-21199
export function getMaxWidth(size) {
  return match(size).with('sm', () => 400).with('md', () => 480).with('lg', () => 560).with('xl', () => 640).otherwise(() => {
    throw new Error(`Invalid size: ${size}`);
  });
}